import type { CSSProperties } from 'react';
import { describeCampaignFrise, type CampaignFrise as CampaignFriseData } from '../systems/campaign-frise';
import styles from './campaign-frise.module.css';

export interface CampaignFriseProps {
  frise: CampaignFriseData;
  /** `page` : ouverture de mission. `fin` : carte de fin de chapitre, frise étalée. */
  variant: 'page' | 'fin';
  className?: string;
}

const CRAN_STATE_CLASS = {
  fait: styles.fait,
  ici: styles.ici,
  remplit: styles.remplit,
  avenir: '',
} as const;

const MISSION_STATE_CLASS = {
  passee: styles.passee,
  cours: styles.cours,
  avenir: '',
} as const;

/** Un cran par chapitre, groupés par mission. Tous les crans ont la même largeur. */
export function CampaignFrise({ frise, variant, className }: CampaignFriseProps) {
  const missionGap = variant === 'fin' ? 10 : 12;
  const cranGapsTotal = (frise.totalChapters - frise.missions.length) * 3;
  const missionGapsTotal = Math.max(0, frise.missions.length - 1) * missionGap;
  const style = {
    '--n': frise.totalChapters,
    '--gaps': `${cranGapsTotal + missionGapsTotal}px`,
  } as CSSProperties;

  return (
    <div
      className={`${styles.frise} ${variant === 'fin' ? styles.fin : ''} ${className ?? ''}`}
      style={style}
      role="img"
      aria-label={describeCampaignFrise(frise)}
    >
      {frise.missions.map((mission) => (
        <div key={mission.id} className={`${styles.m} ${MISSION_STATE_CLASS[mission.state]}`}>
          <div className={styles.crans}>
            {mission.crans.map((cran) => (
              <i key={cran.chapterId} className={`${styles.cran} ${CRAN_STATE_CLASS[cran.state]}`} />
            ))}
          </div>
          <div className={styles.n}>{mission.label}</div>
        </div>
      ))}
    </div>
  );
}
